export const LogoMark = ({ className = "h-8 w-8" }) => (
    <svg viewBox="0 0 32 32" className={className} aria-hidden="true">
        <rect width="32" height="32" rx="7" fill="#2D3E2E" />
        <g fill="#F9F8F3">
            <rect x="8" y="8" width="16" height="3.2" rx="0.5" />
            <rect x="8" y="14.4" width="11" height="3.2" rx="0.5" />
            <rect x="8" y="20.8" width="16" height="3.2" rx="0.5" />
        </g>
    </svg>
);

const Logo = ({ light = false }) => (
    <span className="flex items-center gap-3">
        <LogoMark />
        <span
            className={`font-serif text-sm font-semibold uppercase tracking-[0.22em] ${
                light ? "text-paper" : "text-ink"
            }`}
        >
            Everlast&nbsp;Partners
        </span>
    </span>
);

export default Logo;
